import { toast } from 'react-toastify';
import i18n from 'i18next';

class Alert {
  static alertTextFormatter = (text, params) => i18n.t(text, params);

  static alertService;

  static DEFAULT_ALERT_CONFIG = Object.freeze({
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  static setAlertService(alertService) {
    this.alertService = alertService;
  }

  static showAlert(showAlertFunc, text, params, customConfig = {}) {
    showAlertFunc(this.alertTextFormatter(text, params), {
      toastId: text,
      ...this.DEFAULT_ALERT_CONFIG,
      ...customConfig,
    });
  }

  static showInfo(text, customConfig = {}) {
    this.showAlert(
      this.alertService.info.bind(this.alertService),
      text,
      undefined,
      customConfig
    );
  }

  static showError(text, params, customConfig = {}) {
    this.showAlert(
      this.alertService.error.bind(this.alertService),
      text,
      params,
      customConfig
    );
  }

  static showWarn(text, customConfig = {}) {
    this.showAlert(
      this.alertService.warn.bind(this.alertService),
      text,
      undefined,
      customConfig
    );
  }

  static showSuccess(text, customConfig = {}) {
    this.showAlert(
      this.alertService.success.bind(this.alertService),
      text,
      undefined,
      customConfig
    );
  }
}

Alert.setAlertService(toast);

export default Alert;
